export class Context {
    subscriberId: string;
    ibdId: string;
    loginId: string;
    businessPartyRole: string;
    businessPartyValue: string;
    clientId: string;
}